import React from "react";
import "./SignUp.css";
import { ReactComponent as UserIcon } from "./assets/user-icon.svg";
import { ReactComponent as GoogleIcon } from "./assets/icon-google.svg";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// user-icon src

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleSignUp = async (event) => {
    event.preventDefault();
    console.log(formData);
    try {
      const response = await axios.post(
        "https://foodie-auth.onrender.com/auth/login",
        formData
      );
      const token = response.data.token;
      console.log("token: ", token);

      localStorage.setItem("authToken", token); // Store the token in local storage

      const authData = localStorage.getItem("authToken");
      console.log("Auth data from Login:", authData);

      setFormData({ email: "", password: "" }); // Set email and password to empty strings

      //navigate("/"); // Route to the home page

      // Reload the page
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const handleGoogleSignUp = async () => {
    window.location.href = "https://foodie-auth.onrender.com/auth/auth/google";
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      // Do something with the token
      console.log(token);

      localStorage.setItem("authToken", token); // Store the token in local storage

      const authData = localStorage.getItem("authToken");
      console.log("Auth data from Login:", authData);

      // Edit the URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("token");
      window.history.pushState({}, "", newUrl);
    }
  }, []);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [checkEmail, setCheckEmail] = useState({
    email: "",
  });

  const handleEmail = (event) => {
    setCheckEmail({
      ...checkEmail,
      [event.target.name]: event.target.value,
    });
  };

  const handleCheckEmail = async () => {
    try {
      const response = await axios.post(
        "https://foodie-auth.onrender.com/auth/forgot-password",
        {
          email: checkEmail.email,
        }
      );
      const data = response.data;
      console.log("Response data:", data);
      setIsModalOpen(false);
      // Process the data as needed
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 manual">
      <div className="max-w-md w-full space-y-8">
        <div>
          <UserIcon className="mx-auto h-16 w-auto" />
        </div>
        <form className="mt-8 space-y-6">
          <div className="rounded-md shadow-sm space-y-4">
            <div>
              <label
                htmlFor="email-address"
                className="block text-gray-700 font-bold mb-2"
              >
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-gray-700 font-bold mb-2"
              >
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
              />
              <div className="text-right">
                <button
                  type="button"
                  className="text-xs text-red-600 hover:text-red-800 underline mt-2"
                  onClick={openModal}
                >
                  Forgot Password?
                </button>
                {isModalOpen && (
                  <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="fixed inset-0 bg-black opacity-70"></div>
                    <div className="relative bg-white p-8 rounded-md max-w-md mx-auto">
                      <div className="absolute top-0 right-0">
                        <button
                          className="text-gray-500 hover:text-gray-700 m-2"
                          onClick={closeModal}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="flex flex-col justify-center">
                        <input
                          id="email-address"
                          name="email"
                          type="email"
                          autoComplete="email"
                          required
                          className="appearance-none rounded-md relative block w-full px-4 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 mb-4"
                          placeholder="Email address"
                          value={checkEmail.email}
                          onChange={handleEmail}
                        />
                        <button
                          type="button"
                          onClick={handleCheckEmail}
                          className="px-4 py-2 w-auto text-sm text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:bg-red-700"
                        >
                          Check Email
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center mt-4 space-y-4">
            <button
              type="submit"
              onClick={handleSignUp}
              className="group relative w-36 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 rounded-lg"
            >
              Login
            </button>
            <span>Or</span>
            <button
              type="button"
              onClick={handleGoogleSignUp}
              className="group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 rounded-lg"
            >
              <GoogleIcon className="mr-4 h-7 w-7" />
              Sign in with Google
            </button>
            <div className="text-sm mt-2">
              Don't have an account?{" "}
              <button
                type="button"
                className="text-red-600 hover:text-red-800 underline"
                onClick={() => {
                  navigate("/signup");
                }}
              >
                Signup
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
